<template>
  <div class="pt-3 pl-4 container-calendar">
    <div
      id="scheduled-event-calendar-view"
      class="d-flex flex-row justify-content-start align-items-start"
    >
      <div class="side-bar-content h-100 p-1">
        <div class="filter-container-inner">
          <div class="calendar-container">
            <b-calendar
              v-if="selectedLocation"
              v-model="date"
              hide-header
              locale="en-US"
              width="225px"
            >
            </b-calendar>
          </div>
          <hr class="divider" />
          <div class="sidebar-filters-container">
            <div class="mr-3 mt-3">
              <b-form-group label="Providers">
                <div class="small-selector">
                  <v-select
                    :options="providerUsers"
                    v-model="filter.user"
                    @input="fetchData()"
                    :clearable="false"
                  />
                </div>
              </b-form-group>
            </div>
            <hr class="divider" />
            <div class="pr-2 defined-availabilities-container">
              Defined availabilities
              <provider-availability-detail-card
                v-for="availability in toAvailabilityCards"
                :key="availability.id"
                :availability="availability"
                class="mb-3"
                @edit="
                  data => {
                    data.provider = filter.user.data;
                    availabilityEditor.id = data.id;
                    availabilityEditor.show = true;
                    availabilityEditor.defaultData = data;
                  }
                "
                @delete="data => beforeEventDelete(data)"
              />
              <div class="text-center">
                <b-button
                  variant="light"
                  class="load-more border"
                  @click="getMoreDataCard"
                  v-if="fetchAvailabilities.length > 0"
                >
                  Load More...
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="calendar-content w-100 bg-white">
        <calendar
          v-if="showing"
          class="h-100"
          :date="calendarDate"
          :tbar="tbar"
          :modes="modes"
          :events="calendarEvents"
          :resources="calendarResources"
          :sidebar="false"
          :listeners="listeners"
          :eventTooltipFeature="eventTooltipFeature"
          :eventMenuFeature="eventMenuFeature"
          :dragFeature="dragFeature"
        />
      </div>
    </div>
    <b-modal
      title="Edit recurring availability"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      centered
      ref="form-modal"
      @ok="updateAvailabilities(true)"
      @cancel="fetchData"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <div class="text-right mt-1 mr-2">
          <b-button @click="cancel()" variant="secondary">
            Cancel
          </b-button>
          <b-button class="ml-2" @click="ok()" variant="primary">
            Confirm
          </b-button>
        </div>
      </template>
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          :options="options"
          v-model="selectedOption"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          stacked
        ></b-form-radio-group>
      </b-form-group>
    </b-modal>

    <provider-availability-add-edit-modal
      v-if="availabilityEditor.show"
      v-model="availabilityEditor.show"
      :providerAvailabilityId="availabilityEditor.id"
      :providerAvailabilityDefaultData="availabilityEditor.defaultData"
      @onModify="onModifyAddEditScheduleEvent"
      @onHidden="availabilityEditor.show = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import Calendar from "../../third_party/calendar/Calendar.vue";
import { addClass, removeClass } from "../../helpers/layout";
import userServer from "../../server/user";
import providerAvailabilityServer from "../../server/providerAvailability";
import serviceServer from "../../server/service";
import ProviderAvailabilityAddEditModal from "./ProviderAvailabilityAddEditModal";
import ProviderAvailabilityDetailCard from "./ProviderAvailabilityDetailCard.vue";

export default {
  name: "AvailabilityIndex",
  components: {
    Calendar,
    ProviderAvailabilityAddEditModal,
    ProviderAvailabilityDetailCard
  },
  props: ["showing"],
  data() {
    return {
      providerAvailabilities: [],
      providerAvailabilitiesCard: [],
      fetchAvailabilities: [],

      page: 1,
      users: [],
      availabilityEditor: {
        show: false,
        id: null,
        defaultData: null
      },
      tbar: {
        items: {
          todayButton: false,
          prevButton: false,
          nextButton: false,
          addProviderAvailability: {
            type: "button",
            text: "New Availability",
            color: "b-blue b-raised",
            icon: "b-fa b-fa-calendar-plus",
            cls: "",
            tooltip: "",
            onClick: () => this.addAvailability()
          }
        }
      },
      dragFeature: {
        newName: "New availability",
        recurrenceTip: "",
        validateCreateFn: ({ eventRecord }) => {
          if (
            this.formatDateOnlyMysql(eventRecord.data.startDate) !=
            this.formatDateOnlyMysql(eventRecord.data.endDate)
          ) {
            return false;
          }
          if (
            this.datesNonWorking(null, eventRecord.data.startDate) ||
            this.datesNonWorking(null, eventRecord.data.endDate)
          ) {
            this.showAlertError({
              message:
                "Availabilities cannot be created outside hours of operation"
            });
            return false;
          } else {
            this.addAvailability(eventRecord);
          }
        },
        validateMoveFn: ({ eventRecord }) => {
          if (
            this.formatDateOnlyMysql(eventRecord.data.startDate) !=
            this.formatDateOnlyMysql(eventRecord.data.endDate)
          ) {
            return false;
          }
          if (
            this.datesNonWorking(null, eventRecord.data.startDate) ||
            this.datesNonWorking(null, eventRecord.data.endDate)
          ) {
            this.showAlertError({
              message: "Events cannot be moved outside hours of operation"
            });
            return false;
          }
        },
        validateResizeFn: ({ eventRecord }) => {
          if (
            this.formatDateOnlyMysql(eventRecord.data.startDate) !=
            this.formatDateOnlyMysql(eventRecord.data.endDate)
          ) {
            return false;
          }
        }
      },
      filter: {
        startDate: null,
        endDate: null,
        user: null,
        selectedDate: null
      },
      date: this.formatDateOnlyMysql(),
      listeners: {
        beforeEventEdit: this.beforeEventEdit,
        beforeEventDelete: this.beforeEventDelete,
        dayNumberClick: this.setDate,
        weekNumberClick: this.setDate,
        dateRangeChange: this.dateRangeChange,
        activeItemChange: this.activeItemChange,
        eventClick: this.eventClick,
        dragMoveEnd: this.dragMoveResizeEnd,
        dragResizeEnd: this.dragMoveResizeEnd
      },
      eventMenuFeature: {
        disabled: true
      },
      eventTooltipFeature: {
        showOn: "click",
        renderer: data => {
          const eventData = data.eventRecord.data.eventData;
          return `
            <div class="tooltip-item">
              <div>
                <i class="b-fa b-fa-clock"></i> Date, time and duration
              </div>
              <div class="tooltip-value px-2 m-1">
                ${this.formatDateTimeDuration(
                  eventData.startDateTime,
                  eventData.endDateTime,
                  eventData.allDay
                )}
              </div>
            </div>

            ${
              eventData.services && eventData.services.length
                ? `<div class="tooltip-item">
                    <div>
                      <i class="fas fa-stethoscope"></i> Service(s)
                    </div>
                    ${eventData.services
                      .map(service => {
                        return `
                      <div class="tooltip-value px-2 m-1">
                        ${
                          service.billingCodes[0]
                            ? service.billingCodes[0].cptCode + " - "
                            : ""
                        } ${service.name}
                      </div>`;
                      })
                      .join("")}
                  </div>`
                : ""
            }
            ${
              eventData.placesOfService && eventData.placesOfService.length
                ? `<div class="tooltip-item">
                    <div>
                      <i class="fas fa-map-marker-alt"></i> Places of Service
                    </div>
                    ${eventData.placesOfService
                      .map(placeOfService => {
                        return `
                      <div class="tooltip-value px-2 m-1">
                        ${placeOfService.name}
                      </div>`;
                      })
                      .join("")}
                  </div>`
                : ""
            }
            `;
        },
        tools: {
          edit: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-edit m-0 p-0"
              : "custom-icon custom-icon-edit-prod m-0 p-0"
          },
          delete: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-delete m-0 p-0"
              : "custom-icon custom-icon-delete-prod m-0 p-0"
          },
          close: {
            cls: this.isStandalone()
              ? "custom-icon custom-icon-close m-0 p-0"
              : "custom-icon custom-icon-close-prod m-0 p-0"
          }
        },
        header: {
          titleAlign: "start"
        },
        hideDelay: false
      },
      formData: null,
      options: [
        { value: "ModifySingleAvailability", text: "This availability" },
        {
          value: "ModifyAvailabilityAndRecurrence",
          text: "This and following availabilities"
        },
        { value: "ModifyRecurrence", text: "All availabilities" }
      ],
      selectedOption: "ModifySingleAvailability"
    };
  },

  async mounted() {
    const currentAdjustedDateTime = this.getCurrentAdjustedDateTime();
    this.date = this.formatDateOnlyMysql(currentAdjustedDateTime);
    window.dispatchEvent(new Event("resize"));
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "showAlertError",
      "fetchCurrentUser"
    ]),
    setDate(event) {
      this.date = this.formatDateOnlyMysql(event.date);
    },
    dateRangeChange(event) {
      let startDate = this.formatDateOnlyMysql(event.new.startDate);
      let endDate = this.formatDateOnlyMysql(moment(event.new.endDate));
      this.filter.startDate = startDate;
      this.filter.endDate = endDate;
      if (this.showing) this.fetchData();
    },
    activeItemChange(event) {
      const prevFilter = { ...this.filter };
      this.filter.startDate = this.formatDateOnlyMysql(
        event.activeItem.startDate
      );
      this.filter.endDate = this.formatDateOnlyMysql(
        moment(event.activeItem.endDate)
      );
      if (
        this.filter.startDate != prevFilter.startDate ||
        this.filter.endDate != prevFilter.endDate
      )
        this.fetchData();
    },
    eventClick() {
      const floatRoot = document.querySelectorAll(`.b-float-root`);
      if (floatRoot.length > 0) {
        removeClass(floatRoot[0], "hide-sibling-follow-up");
        addClass(floatRoot[0], "hide-sibling-notes");
        addClass(floatRoot[0], "hide-sibling-view");
      }
    },
    async dragMoveResizeEnd({ eventRecord }) {
      const newStartDate = eventRecord.data.startDate;
      const newEndDate = eventRecord.data.endDate;
      const id = eventRecord.data.eventData.id;
      this.formData = {
        id: id,
        startDateTime: this.formatDateTimeSql(newStartDate),
        endDateTime: this.formatDateTimeSql(newEndDate)
      };
      if (eventRecord.data.eventData.recurrence) {
        this.$refs["form-modal"].show();
      } else {
        await this.updateAvailabilities(false);
        this.page = 0;
        await this.fetchProviderAvailabilityCard();
      }
    },
    async updateAvailabilities(hasRecurrence) {
      if (hasRecurrence) {
        this.formData.modification = this.selectedOption;
      } else {
        this.formData.modification = "ModifySingleAvailability";
      }
      await providerAvailabilityServer.updateDates(
        this.formData.id,
        this.formData
      );
      this.showAlertSuccess();
      this.fetchData();
    },
    beforeEventEdit(event) {
      var defaultData = {
        startDateTime: this.formatDateTimeMysql(
          event.eventRecord.data.startDate
        ),
        endDateTime: this.formatDateTimeMysql(event.eventRecord.data.endDate)
      };
      this.addAvailability(defaultData);

      this.availabilityEditor.id = event.eventRecord?.data.eventData?.id;
      this.availabilityEditor.show = true;
      this.availabilityEditor.defaultData = defaultData;
    },
    beforeEventDelete(event) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          if (event.fromDetailCard && event.availability.recurrenceId) {
            const result = await providerAvailabilityServer.deleteRecurrenceFromCard(
              event.availability.recurrenceId
            );
            if (result.errorCode) {
              this.$dialog.alert("Error: " + result.message);
            } else {
              await this.fetchProviderAvailabilities();
              this.page = 0;
              await this.fetchProviderAvailabilityCard();
              this.showAlertSuccess();
            }
            return;
          }
          let result = await providerAvailabilityServer.delete(
            event.eventRecords
              ? event.eventRecords[0].data.eventData.id
              : event.availability.id
          );
          if (result.errorCode) {
            this.$dialog.alert("Error: " + result.message);
          } else {
            await this.fetchProviderAvailabilities();
            this.page = 0;
            await this.fetchProviderAvailabilityCard();
            this.showAlertSuccess();
          }
        })
        .catch(function() {});
      return false;
    },
    async fetchData() {
      if (this.users.length == 0) {
        await this.fetchUsers();
      }

      if (!this.currentUser) await this.fetchCurrentUser();
      if (!this.filter.user) {
        if (
          this.currentUser.providerInfo &&
          this.currentUser.role.name != "Tech Staff"
        ) {
          this.filter.user = {
            value: this.currentUser.id,
            label: this.formatUser(this.currentUser),
            data: this.currentUser
          };
        } else {
          const provider = this.users.find(user => user.data.providerInfo);
          if (provider) {
            this.filter.user = {
              value: provider.value,
              label: provider.label,
              data: provider.data
            };
          }
        }
      }

      return this.fetchProviderAvailabilities();
    },
    async fetchProviderAvailabilities() {
      this.providerAvailabilities = await providerAvailabilityServer.queryMinimalPaginate(
        {
          providerIds:
            this.filter.user != null ? [this.filter.user.value] : null,
          locationId: this.selectedLocation.id,
          SelectedDateCalendar: this.calendarDate
        }
      );
    },
    addAvailability(defaultData = null) {
      let provider = this.providerUsers.find(
        u => u.value == this.filter.user.value
      ).data;
      if (defaultData != null) {
        defaultData.provider = provider;
      } else {
        defaultData = {
          provider: provider
        };
      }
      this.fetchData();
      this.availabilityEditor.id = null;
      this.availabilityEditor.show = true;
      this.availabilityEditor.defaultData = defaultData;
    },
    async onModifyAddEditScheduleEvent() {
      this.availabilityEditor.show = false;
      await this.fetchData();
      this.page = 0;
      await this.fetchProviderAvailabilityCard();
    },
    async fetchUsers() {
      const users = await userServer.getUserServices();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
    },
    async fetchServices() {
      const services = await serviceServer.query({
        type: "Service"
      });
      this.services = services.map(service => ({
        value: service.id,
        adadvalue: service.id,
        label: `${service.billingCode} - ${service.name}`,
        data: service,
        costPerUnit: service.costPerUnit,
        numberOfUnits: 1
      }));
    },
    eventRenderer({ eventRecord }) {
      var user = eventRecord.data.eventData?.provider
        ? eventRecord.data.eventData.provider.fullName
        : "<span class='text-danger'> No provider selected </span>";

      const startDate = this.formatTimeOnly(eventRecord.data.startDate);

      const endDate = this.formatTimeOnly(eventRecord.data.endDate);

      return `<div style="font-size:13px;">
        ${user}, ${startDate} - ${endDate}
      </div>`;
    },
    monthEventRenderer({ eventRecord }) {
      var user = eventRecord.data.eventData?.provider
        ? eventRecord.data.eventData.provider.fullName
        : "<span class='text-danger'> No provider selected </span>";

      const startDate = this.formatTimeOnly(eventRecord.data.startDate);

      const endDate = this.formatTimeOnly(eventRecord.data.endDate);

      return `<div class="d-flex align-items-center" style="font-size:13px;">
        ${user}, ${startDate} - ${endDate}
      </div>`;
    },
    async fetchProviderAvailabilityCard() {
      this.fetchAvailabilities = await providerAvailabilityServer.queryMinimalCard(
        {
          providerIds:
            this.filter.user != null ? [this.filter.user.value] : null,
          locationId: this.selectedLocation.id,
          SelectedDateCalendar: this.calendarDate,
          Page: this.page
        }
      );
      if (this.page > 0) {
        this.providerAvailabilitiesCard = [
          ...this.providerAvailabilitiesCard,
          ...this.fetchAvailabilities
        ];
      }
      if (this.page === 0) {
        this.providerAvailabilitiesCard = this.fetchAvailabilities;
      }
    },
    async getMoreDataCard() {
      this.page++;

      await this.fetchProviderAvailabilityCard();
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    ...mapGetters("layout", ["datesNonWorking"]),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapGetters("client", ["selectedLocation"]),
    modes() {
      const dayStartTime =
        this.selectedLocation && this.selectedLocation.operationStarts
          ? this.selectedLocation.operationStarts
          : 8;
      const dayEndTime =
        this.selectedLocation && this.selectedLocation.operationEnds
          ? this.selectedLocation.operationEnds
          : 18;
      return {
        agenda: null,
        day: {
          hourHeight: 80,
          dayStartTime: dayStartTime,
          dayEndTime: dayEndTime,
          eventRenderer: this.eventRenderer
        },
        week: {
          hourHeight: 80,
          dayStartTime: dayStartTime,
          dayEndTime: dayEndTime,
          eventRenderer: this.eventRenderer
        },
        month: {
          eventRenderer: this.monthEventRenderer
        },
        year: null
      };
    },
    calendarDate() {
      return moment(this.date).toDate();
    },
    calendarEvents: {
      get() {
        const events = [];
        const availabilities = this.providerAvailabilities;
        for (let index = 0; index < availabilities.length; index++) {
          const availability = availabilities[index];
          let endDate;

          const endOfDay = moment(availability.sTime).endOf("day");
          endDate = moment(availability.eTime);

          if (endDate > endOfDay) {
            endDate = endOfDay;
          }

          events.push({
            eventData: availability,
            startDate: moment(availability.startDateTime).toDate(),
            eventColor: "#1E50B3",
            endDate: moment(availability.endDateTime).toDate(),
            resourceId: null,
            name: availability.provider.fullName,
            iconCls: ""
          });
        }

        if (events.length === 0) {
          events.push({});
        }

        return events;
      }
    },
    calendarResources: {
      get() {
        return [];
      }
    },
    providerUsers() {
      return this.users.filter(u => u.data.providerInfo);
    },
    toAvailabilityCards() {
      const filteredItems = this.providerAvailabilitiesCard.filter(item => {
        if (!item.recurrence) {
          return true;
        }
        return (
          this.providerAvailabilitiesCard.findIndex(
            i => i.recurrence && i.recurrenceId === item.recurrenceId
          ) === this.providerAvailabilitiesCard.indexOf(item)
        );
      });

      return filteredItems;
    }
  },
  watch: {
    "filter.user": async function() {
      this.page = 0;
      await this.fetchProviderAvailabilityCard();
    }
  }
};
</script>

<style scoped>
.container-calendar {
  box-shadow: inset 0px 16px 10px -16px rgb(0 0 0 / 75%);
}
#scheduled-event-calendar-view {
  height: calc(100vh - 50px);
}
.sidebar-filters-container {
  min-height: calc(100vh - 298px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: -20px;
  padding-left: 10px;
  padding-bottom: 120px;
}
.defined-availabilities-container {
  max-height: calc(100vh - 446px);
  overflow-y: auto;
  overflow-x: hidden;
}
.divider {
  margin: 10px 8px 10px -19px;
}
.calendar-container {
  text-align: center;
}

.filter-container-inner {
  width: 250px;
  padding: 0px;
}
</style>
<style>
#scheduled-event-calendar-view .calendar-content .b-calendar-days {
  min-height: 85px;
}
#scheduled-event-calendar-view .b-grid-header-resizable {
  background-color: #0062cc;
  color: white;
  align-items: center;
}
#scheduled-event-calendar-view .b-grid-header-resizable:hover {
  background-color: #0062cc !important;
}
#scheduled-event-calendar-view .b-calendar {
  display: initial !important;
}
#scheduled-event-calendar-view .b-sidebar {
  display: initial !important;
  position: initial !important;
  width: initial !important;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-content {
  height: calc(100vh - 150px) !important;
}
#scheduled-event-calendar-view .b-float-root {
  z-index: 10 !important;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
  font-size: 15px;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}
#scheduled-event-calendar-view .b-calendar-nav {
  position: relative;
}
#scheduled-event-calendar-view .b-calendar-nav button {
  display: none !important;
}
#scheduled-event-calendar-view .b-calendar-nav button:nth-child(2) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 30px;
  top: 5px;
}
#scheduled-event-calendar-view .b-calendar-nav button:nth-child(4) {
  display: block !important;
  flex: none !important;
  position: absolute;
  right: 0px;
  top: 5px;
}
#scheduled-event-calendar-view .b-calendar-grid-weekdays.border-bottom {
  border-bottom: none !important;
}

#scheduled-event-calendar-view .b-calendar .b-calendar-inner .font-weight-bold {
  font-weight: 400 !important;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-inner .text-muted {
  color: #d8d8d8 !important;
}
#scheduled-event-calendar-view .b-calendar-grid-help {
  display: none;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-grid {
  border: none;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-inner {
  min-width: 200px !important;
}
#scheduled-event-calendar-view .b-calendar-grid-caption.text-center {
  text-align: left !important;
}
#scheduled-event-calendar-view .b-calendar .b-calendar-grid {
  background-color: transparent !important;
}
#scheduled-event-calendar-view .b-calendar > .b-top-toolbar {
  background-color: #f5f8fc !important;
}
#scheduled-event-calendar-view label {
  margin-bottom: 0px !important;
}
#scheduled-event-calendar-view .font-size-icon::before {
  font-size: 17px !important;
}
#scheduled-event-calendar-view .little-badge {
  font-size: 11px;
}
#scheduled-event-calendar-view {
  -webkit-user-select: none; /* Safari */
  -webkit-touch-callout: none; /* iOS Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
#scheduled-event-calendar-view
  .b-calendar
  .b-calendar-grid-body
  .col[data-date]
  .btn,
#scheduled-event-calendar-view .b-calendar-grid-weekdays.border-bottom small {
  font-size: 12px !important;
}
#scheduled-event-calendar-view .form-group legend {
  font-size: 13px !important;
  color: #495057;
}

#scheduled-event-calendar-view .b-calendar-week > .b-calendar-cell {
  display: none !important;
}

.calendar-content .event-name-label {
  font-size: 13px;
}
.calendar-content .b-weekview .b-event-header,
.calendar-content .b-dayview .b-event-header {
  display: none;
}
.calendar-content .b-calendarrow .b-cal-cell-header {
  padding-top: 10px !important;
}

.calendar-content .b-calendarrow .b-cal-cell-header .b-day-name-date {
  font-size: 1.5em;
}
.calendar-content .b-dayview-day-container .b-calendar-cell .b-cal-event-body {
  padding: 1px 0px 0px 5px !important;
}
.calendar-content .b-calendar-view-desc {
  margin-left: 0px !important;
}
.calendar-content .b-toolbar.b-dock-top,
.b-toolbar.b-dock-bottom {
  min-height: 3.2em;
}
.container-calendar .vs__dropdown-menu {
  max-height: 150px !important;
}
.container-calendar .items-list-container {
  max-height: 165px !important;
}
.hide-sibling-notes .custom-icon-notes {
  display: none;
}
.hide-sibling-view .custom-icon-view {
  display: none;
}
.hide-sibling-follow-up .custom-icon-follow-up {
  display: none;
}
.hide-sibling-edit .custom-icon-edit {
  display: none;
}

.b-panel-header .b-header-title {
  font-size: 16px;
}

.tooltip-participants-container .col-sm-6 {
  padding: 0px 5px !important;
}

.tooltip-value {
  font-size: 14px;
}

.tooltip-item {
  margin-top: 10px;
}

.small-selector {
  font-size: 13px;
}
</style>
